/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request to reschedule an appointment slot to a new start time.
 */
export interface RescheduleSlotRequest {
  /** New start time for the slot (end is derived from existing duration) */
  startTime: string;
}
